<template lang="pug">
    .about-ourvisionfor5g
        .about-ourvisionfor5g-title
            p   {{ lenguageSelected.title }}
        .about-ourvisionfor5g-content
            .about-ourvisionfor5g-content-title {{ lenguageSelected.subtitle1 }}
            .about-ourvisionfor5g-content-description   {{ lenguageSelected.desc1 }}
            img(style="margin-top: 60px; margin-bottom: 60px;", :src="lenguageSelected.image")
            .about-ourvisionfor5g-content-title {{ lenguageSelected.subtitle2 }}
            .about-ourvisionfor5g-content-list
                ul
                    li(v-for="list in lenguageSelected.list1")  {{ list }}
            .about-ourvisionfor5g-content-box
                |   {{ lenguageSelected.box }}
</template>


<script>
import image from '@img/about/OurVisiofor5G_2.jpg'
import image_esp from '@img/about/OurVisiofor5G_2_esp.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                title: '5G technology represents the future of our networked society. This new distribution platform is sure to change the way we interact and communicate.',
                subtitle1: 'Comparing 4G and 5G ',
                desc1: 'Exponential data growth is driving demand for digital infrastructure',
                subtitle2: 'Network Requirements',
                list1: [
                    'Low latency: 5G deployment will increase speed and decrease latency over the air interface',
                    'Data / Cyber Security',
                    'Localized content and applications',
                    'High bandwidth',
                    '5G will produce improvements in both core processing and transport (fronthaul and backhaul)'
                ],
                box: 'From Core to Edge, 5G Deployment Requires an Enhanced Digital Infrastructure Backbone.',
                image: image
            },
            lenguageES: {
                title: '5G representa la plataforma del futuro para una sociedad conectada. Esta tecnología de distribución cambiará la forma en que nos interactuamos y comunicamos.',
                subtitle1: 'Comparando 4G y 5G',
                desc1: 'El crecimiento exponencial de datos está impulsando la demanda de infraestructura digital',
                subtitle2: 'Requisitos de red',
                list1: [
                    'Baja latencia: el despliegue de 5G aumentará la velocidad y disminuirá la latencia en la interfaz aérea',
                    'Mayor capacidad de transmisión de datos / seguridad cibernética',
                    'Contenido localizado',
                    'Mayor ancho de banda',
                    '5G will produce improvements in both core processing and transport (fronthaul and backhaul)'
                ],
                box: 'Desde el centro de la red hasta la orilla (el “Edge”), la implementación de 5G requiere un crecimiento en la red troncal de infraestructura digital.',
                image: image_esp
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmOurVisionFor5g.vue